import { render, staticRenderFns } from "./index.vue?vue&type=template&id=28ae02de&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=28ae02de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae02de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28ae02de')) {
      api.createRecord('28ae02de', component.options)
    } else {
      api.reload('28ae02de', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=28ae02de&scoped=true", function () {
      api.rerender('28ae02de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/editInfo/index.vue"
export default component.exports